import React from "react";
import theme from "../theme/theme1"; // Import the theme

const campusLifeData = [
  {
    title: "Student Life",
    description:
      "A dynamic and nurturing environment with modern housing, exceptional dining, and over 500 student organizations fostering personal and academic growth.",
    linkText: "Student Affairs",
    linkHref: "#",
    imageUrl:
      "https://www.stanford.edu/wp-content/uploads/2022/04/Campus-life-1.jpg",
  },
  {
    title: "Arts & Culture",
    description:
      "A rich tradition of fostering creativity through various art forms, with dedicated spaces and events to showcase student talent.",
    linkText: "Velammal Arts",
    linkHref: "#",
    imageUrl:
      "https://www.stanford.edu/wp-content/uploads/2022/04/Campus-life-2.jpg",
  },
  {
    title: "Recreation & Wellness",
    description:
      "State-of-the-art sports facilities and wellness programs ensuring students stay fit and healthy, encouraging balance between academics and recreation.",
    linkText: "Recreation & Wellness",
    linkHref: "#",
    imageUrl:
      "https://www.stanford.edu/wp-content/uploads/2022/04/Campus-life-3.jpg",
  },
];

const CampusLife = () => {
  return (
    <section
       className="py-12 px-4 bg-gradient-to-r from-[#b3a369] to-[#f8f4e8] font-sans relative overflow-hidden"
  style={{ fontFamily: theme.fontFamily }}
      
    >
         
      {/* Soft Lighting Effects */}
      <div className="absolute inset-0 bg-radial-gradient-light"></div>

      {/* Parallax Scrolling Background */}
      <div className="absolute inset-0 bg-parallax-light"></div>
      {/* Video Background with Overlay */}
    

      <div
        className="text-center mb-12 relative z-10"
        style={{
          color: theme.campusLifeSection.headingTextColor, // Heading text color from theme
        }}
      >
        <h2 className="text-4xl lg:text-5xl font-extrabold tracking-wide">
          Campus Life at Velammal School
        </h2>
        <p
          className="mt-4 text-lg lg:text-xl max-w-2xl mx-auto leading-relaxed"
          style={{
            color: theme.campusLifeSection.paragraphTextColor, // Paragraph text color
          }}
        >
          Building a vibrant community of young, ambitious minds dedicated to
          both academic excellence and personal development.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto relative z-10">
        {campusLifeData.map((item, index) => (
          <div
            key={index}
            className="bg-white shadow-2xl overflow-hidden transition-transform transform hover:scale-105 hover:shadow-2xl border border-gray-200"
            style={{
              borderRadius: "0",
              boxShadow: theme.campusLifeSection.cardShadow, // Card shadow from theme
            }}
          >
            <img
              src={item.imageUrl}
              alt={item.title}
              className="w-full h-56 md:h-64 lg:h-72 object-cover"
              style={{
                borderRadius: "0",
                boxShadow: theme.campusLifeSection.imageShadow, // Image shadow from theme
              }}
            />
            <div className="p-6">
              <h3
                className="text-xl lg:text-2xl font-semibold"
                style={{
                  color: theme.campusLifeSection.cardTitleTextColor, // Title text color from theme
                }}
              >
                {item.title}
              </h3>
              <p
                className="text-gray-700 mt-3 leading-relaxed"
                style={{
                  color: theme.campusLifeSection.cardTextColor, // Description text color
                }}
              >
                {item.description}
              </p>
              <a
                href={item.linkHref}
                className="font-semibold mt-4 inline-block hover:text-[#13294b] transition-all duration-300"
                style={{
                  color: theme.campusLifeSection.linkTextColor, // Link text color from theme
                }}
                onMouseEnter={(e) => {
                  e.target.style.color =
                    theme.campusLifeSection.linkHoverTextColor; // Hover color from theme
                }}
                onMouseLeave={(e) => {
                  e.target.style.color =
                    theme.campusLifeSection.linkTextColor; // Reset hover color
                }}
              >
                {item.linkText} &gt;
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default CampusLife;
